// Dont load in test env because API makers error-logger already load source maps and loading twice fucks it up
const peakFlowErrors = globalThis.peakFlowErrors || globalThis.peakflowErrors
const tensorBuzzErrors = globalThis.tensorBuzzErrors || globalThis.tensorbuzzErrors

const loadSourceMapForScriptTags = (bugReporter) => {
  bugReporter.loadSourceMapForScriptTags((scriptTag) => {
    const src = scriptTag.getAttribute("src")
    const type = scriptTag.getAttribute("type")

    if (src && src.includes("/packs/") && (type == "text/javascript" || !type)) {
      const url = bugReporter.loadUrl(src)

      if (!url) {
        return false
      }

      const originalUrl = `${url.origin}${url.pathname}`

      return originalUrl
    }

    return false
  })
}

const enableTensorBuzzSourceMapsLoader = (remainingAttempts) => {
  if (tensorBuzzErrors.enableSourceMapsLoader()) {
    return
  }

  if (remainingAttempts <= 1) {
    console.warn("TensorBuzz source-map loader was not ready before attempts ran out")

    return
  }

  globalThis.setTimeout(() => {
    enableTensorBuzzSourceMapsLoader(remainingAttempts - 1)
  }, 50)
}

if (globalThis.RAILS_ENV != "test") {
  if (peakFlowErrors) {
    loadSourceMapForScriptTags(peakFlowErrors)
  }

  if (tensorBuzzErrors) {
    loadSourceMapForScriptTags(tensorBuzzErrors)
    enableTensorBuzzSourceMapsLoader(10)
  }
}
